import { render } from "./dashboardPayments.vue?vue&type=template&id=a839e7bc&scoped=true"
import script from "./dashboardPayments.vue?vue&type=script&lang=js"
export * from "./dashboardPayments.vue?vue&type=script&lang=js"

import "./dashboardPayments.vue?vue&type=style&index=0&id=a839e7bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a839e7bc"]])

export default __exports__